import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import {
  financialRatioHighlightThunk,
  getIndustryMedianRiskScoreThunk,
  getRiskScaleInterpretationThunk,
} from './thunk'

const slice = createSlice({
  name: 'industryAnalysis/highlight',
  initialState: {
    isLoadingRiskScore: true,
    riskScaleInterpretation: [],
    industry: {},
    isLoadingIndustry: false,
    highlightItems: {},
    isLoadingHighlightItems: false,
  },
  reducers: {
    changeTab: (state, action) => {
      state.tab = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRiskScaleInterpretationThunk.pending, (state) => {
      state.isLoadingRiskScore = true
    })
    builder.addCase(
      getRiskScaleInterpretationThunk.fulfilled,
      (state, action) => {
        state.riskScaleInterpretation = action.payload
        state.isLoadingRiskScore = false
      },
    )
    builder.addCase(
      getRiskScaleInterpretationThunk.rejected,
      (state, action) => {
        state.isLoadingRiskScore = action.payload.loading
      },
    )

    builder.addCase(getIndustryMedianRiskScoreThunk.pending, (state) => {
      state.isLoadingIndustry = true
    })
    builder.addCase(
      getIndustryMedianRiskScoreThunk.fulfilled,
      (state, action) => {
        state.industry = action.payload
        state.isLoadingIndustry = false
      },
    )
    builder.addCase(
      getIndustryMedianRiskScoreThunk.rejected,
      (state, action) => {
        state.isLoadingIndustry = action.payload.loading
      },
    )

    builder.addCase(financialRatioHighlightThunk.pending, (state) => {
      state.isLoadingHighlightItems = true
    })
    builder.addCase(financialRatioHighlightThunk.fulfilled, (state, action) => {
      const data = action.payload.reduce((acc, item) => {
        acc[item.ratioCode] = item
        return acc
      }, {})
      state.highlightItems = data
      state.isLoadingHighlightItems = false
    })
    builder.addCase(financialRatioHighlightThunk.rejected, (state, action) => {
      state.isLoadingHighlightItems = action.payload.loading
    })
  },
})

register(slice.name, slice.reducer)

export const selectLoadingRiskScaleInterpretation = (state) =>
  state[slice.name].isLoadingRiskScore
export const selectRiskScaleInterpretation = (state) =>
  state[slice.name].riskScaleInterpretation
export const selectIndustryHighlight = (state) => state[slice.name].industry
export const selectLoadingIndustryHighlight = (state) =>
  state[slice.name].isLoadingIndustry
export const selectHighlightItems = (state) => state[slice.name].highlightItems
export const selectLoadingHighlightItems = (state) =>
  state[slice.name].isLoadingHighlightItems

export const { changeTab, changePeriod, changeIsShowRange } = slice.actions
